import { NestedHome, NestedSearch } from "@habity/types";

/** Get lat/long from address; fall back to GeoJSON location.coordinates [lng, lat] when needed */
function coordinatesFromAddress(
  address: {
    latitude?: number | null;
    longitude?: number | null;
    location?: unknown;
  } | null
): { latitude: number | undefined; longitude: number | undefined } {
  if (!address) return { latitude: undefined, longitude: undefined };
  const coords = (address.location as { coordinates?: number[] } | null)
    ?.coordinates;
  return {
    latitude:
      address.latitude ??
      (Array.isArray(coords) && coords[1] != null ? coords[1] : undefined),
    longitude:
      address.longitude ??
      (Array.isArray(coords) && coords[0] != null ? coords[0] : undefined),
  };
}

export const getFiltersFromHome = (home: NestedHome): Partial<NestedSearch> => {
  const { address, price, estimate } = home || {};
  const { category, living_space, rooms } = address || {};
  const { latitude, longitude } = coordinatesFromAddress(address);
  const homePrice = price || estimate;

  return {
    longitude,
    latitude,
    categories: category ? [category] : [],
    price_min: homePrice ? Math.round(homePrice - homePrice * 0.1) : undefined,
    price_max: homePrice ? Math.round(homePrice + homePrice * 0.3) : undefined,
    living_space_min: living_space
      ? Math.round(living_space - living_space * 0.3)
      : undefined,
    living_space_max: living_space
      ? Math.round(living_space + living_space * 0.3)
      : undefined,
    rooms_min: rooms && rooms <= 5 ? rooms - 1 : rooms ? rooms - 2 : undefined,
    rooms_max: rooms && rooms <= 5 ? rooms + 1 : rooms ? rooms + 3 : undefined,
    // When searching based on a specific home, require brokers whose area contains the point
    requireContainingArea: true,
  };
};
